var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form-page tw-pt-6 lg:tw-pt-10"},[(!_vm.$store.state.formSuccess)?_c('Form'):_vm._e(),(_vm.$store.state.formSuccess)?_c('FormSuccess',[_vm._v(" Thank you message ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }